module.exports = __webpack_public_path__ + "assets/img/29_228_big.ce44d77b.jpg";